export default __webpack_public_path__ + "static/media/close_square.123f5153.svg";